import { render, staticRenderFns } from "./SampleTypesModal.vue?vue&type=template&id=e18ea0d6&scoped=true&"
import script from "./SampleTypesModal.ts?vue&type=script&lang=ts&"
export * from "./SampleTypesModal.ts?vue&type=script&lang=ts&"
import style0 from "./SampleTypesModal.scss?vue&type=style&index=0&id=e18ea0d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18ea0d6",
  null
  
)

export default component.exports